document.addEventListener('DOMContentLoaded', function () {
  const consentLink = document.querySelector(
    '#menu-lien-footer li.lien-footer-6__subnav__0 a.nav-item__link'
  );

  if (consentLink) {
    consentLink.setAttribute('href', 'javascript:Didomi.preferences.show()');
  }
});
